import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';
import { InputErrorMessage, MESSAGES } from '~/utilities';

interface LocationServices {
  autocompleteService: google.maps.places.AutocompleteService | null;
  geocoder: google.maps.Geocoder | null;
  isLoading: boolean;
  error: InputErrorMessage | null;
  isReady: boolean;
}

export const useLocationServices = (): LocationServices => {
  const placesLib = useMapsLibrary('places');
  const geocodeLib = useMapsLibrary('geocoding');
  const [autocompleteService, setAutocompleteService] =
    useState<google.maps.places.AutocompleteService | null>(null);
  const [geocoder, setGeocoder] = useState<google.maps.Geocoder | null>(null);
  const [error, setError] = useState<InputErrorMessage | null>(null);

  useEffect(() => {
    if (!placesLib || !geocodeLib) return;

    try {
      const newAutocompleteService = new placesLib.AutocompleteService();
      const newGeocoder = new geocodeLib.Geocoder();

      setAutocompleteService(newAutocompleteService);
      setGeocoder(newGeocoder);
      setError(null);
    } catch (err) {
      setError(MESSAGES.placesServiceError);
      setAutocompleteService(null);
      setGeocoder(null);
    }
  }, [geocodeLib, placesLib]);

  const isLoading = !placesLib || !geocodeLib;
  const isReady = !!(autocompleteService && geocoder && !error);

  return {
    autocompleteService,
    geocoder,
    isLoading,
    error,
    isReady,
  };
};
